/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { getFuturesForecastsModels } from "../../funcs/getFuturesForecastsModels.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetFuturesForecastsModelsRequest$inboundSchema,
};

export const tool$getFuturesForecastsModels: ToolDefinition<typeof args> = {
  name: "get-futures-forecasts-models",
  description: `Get Forecast Models for a future

Return a list of all forecast models for a given future symbol.  Forecast models generate forecasts at various horizons`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await getFuturesForecastsModels(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
